import { render, staticRenderFns } from "./ai-vr-scene.vue?vue&type=template&id=624890f0&scoped=true&lang=html"
import script from "./ai-vr-scene.vue?vue&type=script&lang=js"
export * from "./ai-vr-scene.vue?vue&type=script&lang=js"
import style0 from "./ai-vr-scene.vue?vue&type=style&index=0&id=624890f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624890f0",
  null
  
)

export default component.exports